import { Controller } from "@hotwired/stimulus";
import { application } from "src/stimulus/application";

// landIeul: components/FAQ/FAQItem/index.tsx の useState(isOpen) を再現。
// クリックで answerSection の表示/非表示と矢印回転 (aria-expanded による CSS) を切り替える。
class SiteFaqFaqItemController extends Controller {
  static targets = ["button", "answer"];

  declare readonly buttonTarget: HTMLButtonElement;
  declare readonly answerTarget: HTMLElement;

  toggle(): void {
    const open = this.buttonTarget.getAttribute("aria-expanded") === "true";
    this.buttonTarget.setAttribute("aria-expanded", String(!open));
    this.answerTarget.hidden = open;
  }
}

application.register("site--faq--faq-item", SiteFaqFaqItemController);
